export const currencyRegEx =
  /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;

export const emailRegEx =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Commonly needed RegExps
const ipRegExpCore = /([0-9]{1,3}\.){3}[0-9]{1,3}/;

export const ipRegExp = new RegExp(`^${ipRegExpCore.source}$`);

const ipRangeRegExpCore = /\/([0-9]|[1-2][0-9]|3[0-2])/;

export const ipWithOptionalRangeRegExp = new RegExp(
  `^${ipRegExpCore.source}(${ipRangeRegExpCore.source})?$`
);

export const ipWideStrictRangeRegExp = new RegExp(
  "^" +
    "(?:" +
    // IPv4
    "(?:25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)\\." +
    "(?:25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)\\." +
    "(?:25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)\\." +
    "(?:25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)" +
    "(?:\\/(?:[0-9]|[1-2][0-9]|3[0-2]))?" +
    "|" +
    // IPv6 long
    "(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}" +
    "(?:\\/(?:[0-9]|[1-9]\\d|1[01]\\d|12[0-8]))?" +
    "|" +
    // IPv6 short with ::
    "(?=(?:.*::){1})(?:(?:[a-fA-F0-9]{1,4}:){0,6}[a-fA-F0-9]{1,4})?" +
    "::(?:[a-fA-F0-9]{1,4}:?){0,6}" +
    "(?:\\/(?:[0-9]|[1-9]\\d|1[01]\\d|12[0-8]))?" +
    ")" +
    "$"
);

export const domainRegExp =
  /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;

// Numeric values only (integers)
export const integerRegEx = /^\d+$/i;

// Use only numeric values between 0-100 (float)
export const percentRegEx = /^(?!0+(?:\.0+)?$)\d?\d(?:\.\d\d?)?$/;

// TrafficSource Postback URL
export const postbackTrafficSourceRegEx =
  /\b((?:https?|ftp):\/\/[\w-]+(?:\.[\w-]+)+|(?:[0-9]{1,3}\.){3}[0-9]{1,3})\b/;

// Google Ads id account
export const googleAccountIdRegEx = /^(\d{10}|\d{3}-\d{3}-\d{4})$/;

// url regex
export const urlRegex =
  /(?:https?:\/\/)?(?:www\.)?[^\s/$.?#].[^\s]*\.[^\s/$.?#].[^\s]*$/i;
